export const fuzzyWuzzy = '#cc6666';
export const fuzzyWuzzyInverted = '#339999';
export const fuzzyWuzzyInvertedLight = '#a0cccb';
// export const floralwhite = '#FEF9E7';
// export const floralwhite = '#5DBCD2';
export const floralwhite = '#FBEEE6';
// export const floralwhite = '#f8fcff';
export const white = '#fff';

export const primaryColor = fuzzyWuzzy;
export const primaryColorLight = '#f3ccc9';
export const secondaryColor = fuzzyWuzzyInverted;
export const secondaryColorLight = fuzzyWuzzyInvertedLight;

export const blackGray = '#1f1f1f';
export const darkGray = '#4c4c4c';
export const gray = '#777777';
export const lightGray = '#959595';
